import { render, staticRenderFns } from "./add-single-chart.vue?vue&type=template&id=13038bd8&scoped=true&"
import script from "./add-single-chart.vue?vue&type=script&lang=js&"
export * from "./add-single-chart.vue?vue&type=script&lang=js&"
import style0 from "./add-single-chart.vue?vue&type=style&index=0&id=13038bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13038bd8",
  null
  
)

export default component.exports